import React from "react";
import { Card, CardContent, Box } from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import image from '../../../../assest/images/Open_Doodles_-_Messy-removebg-preview.png'



const PerformanceChart = ({ employeeData }) => {

    return (
        // <Card sx={{
        //     borderRadius: 6,
        //     boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
        //     height: '100%',
        //     backgroundColor: '#e7ecf2',
        //     position: 'relative',
        //     overflow: 'hidden',
        // }}>
        //     <CardContent sx={{ p: 0, height: '100%', position: 'relative' }}>
                <MaterialBox sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: '100%',
                    px: 3,
                    py: 1
                }}>
                    <MaterialBox
                        component="img"
                        src={image}
                        alt="Performance Illustration"
                        sx={{
                            width: "200px",
                            height: "200px",
                            ml: -2,
                            mt: 1,
                            objectFit: 'contain'
                        }}
                    />
                    <MaterialBox sx={{ textAlign: 'right', flex: 1 }}>
                        <MaterialTypography
                            variant="body2"
                            fontWeight="800"
                            sx={{
                                color: "#1e2a78",
                                lineHeight: 1.2,
                                fontSize: "0.8rem",
                                fontStyle: 'italic',
                                textShadow: '0 2px 4px rgba(0,0,0,0.05)'
                            }}
                        >
                            "Don’t ghost your tasks— your updates drive both your performance and the project’s success"
                        </MaterialTypography>
                    </MaterialBox>
                </MaterialBox>
        //     </CardContent>
        // </Card>
    );
};

export default PerformanceChart;
